// extracted by mini-css-extract-plugin
export var avatarContainer = "_c3-0";
export var avatarTypingWave = "_c3-i";
export var gray = "_c3-f";
export var green = "_c3-c";
export var icon = "_c3-9";
export var image = "_c3-1";
export var lg = "_c3-6";
export var md = "_c3-5";
export var presenceDot = "_c3-b";
export var red = "_c3-d";
export var sm = "_c3-4";
export var status = "_c3-a";
export var typingDot = "_c3-h";
export var typingPill = "_c3-g";
export var xl = "_c3-7";
export var xs = "_c3-3";
export var xxl = "_c3-8";
export var xxs = "_c3-2";
export var yellow = "_c3-e";